module.exports = __webpack_public_path__ + "media/images/app/icons/checkmark-circle-738cce08e29b266049bca7a6d77cac7a.svg";